import React from 'react'
import _ from 'lodash'
import classes from './PatientInfo.css'
import FormattedDate from '../../components/FormattedDate'
import GetAge from '../../components/GetAge'
import EnrollmentDates from '../../components/EnrollmentDates'
import {
  truncate,
  getTemplateName,
} from '../../components/PatientInfoUtils'
import { getPhysicianName } from '../../containers/Utilities'
import { getDateFormat } from '../../constants'

export const PatientInfo = props => {
  const {
    columnTwoStyle,
    participant: {
      connectionStatus,
      connectionTemplateID,
      customParticipantID,
      dob,
      enrollment,
      fetching,
      firstName,
      id,
      lastName,
      orderingPhysician,
      prescribed,
      sex,
      notes,
    },
    ecgView = false,
    showAllDetails = true,
    orderingPractice,
    me,
  } = props

  const dateFormat = getDateFormat(me)

  return (
    <div className={`${classes.patientInfo} ${ecgView && classes.ecgView}`}>
      {showAllDetails &&
        <React.Fragment>
          <div className={classes.columnOne}>
            <div className={classes.row}>
              <div className={classes.infoTitleShort}>
                MRN:
              </div>
              <div className={classes.info}>
                {truncate(customParticipantID)}
              </div>
            </div>
            <div className={classes.row}>
              <div className={classes.infoTitleShort}>
                DOB:
              </div>
              <div className={classes.info}>
                <FormattedDate date={dob} fmt={dateFormat} me={me}/>
                &nbsp;(<GetAge dob={dob} />)
              </div>
            </div>

            <div className={classes.row}>
              <div className={classes.infoTitleShort}>
                Sex:
              </div>
              <div className={classes.info}>
                {_.startCase(sex)}
              </div>
            </div>
          </div>
          <div
            className={classes.columnTwo}
            style={columnTwoStyle}
          >
            <div className={classes.row}>
              <div className={classes.infoTitleLong}>
                Provider:
              </div>
              <div className={classes.info}>
                {orderingPhysician ? getPhysicianName(orderingPhysician.firstName, orderingPhysician.lastName) : '-'}
              </div>
            </div>

            <div className={classes.row}>
              <div className={classes.infoTitleLong}>
                Connection Plan:
              </div>
              <div className={classes.info}>
                {getTemplateName(enrollment)}
              </div>
            </div>

            <div className={classes.row}>
              <div className={classes.infoTitleLong}>
                Connection Period:
              </div>
              <div className={classes.info}>
                <EnrollmentDates
                  enrollment={enrollment}
                  dateFormat={dateFormat}
                  me={me}
                />
              </div>
            </div>

          </div>
        </React.Fragment>
      }
      {!showAllDetails &&
        <div className={classes.fullRow}>
          <div className={classes.row}>
            <div className={classes.infoTitleLong}>
              Ordering Practice:
            </div>
            <div className={classes.info}>
              {orderingPractice.name}
            </div>
          </div>
        </div>
      }
      {!ecgView &&
        <div className={classes.fullRow}>
          <div className={classes.row}>
            <div className={classes.infoTitleShort}>
              Notes:
            </div>
            <div className={classes.info}>
              {notes === null ? '-' : notes}
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default PatientInfo



// WEBPACK FOOTER //
// ./src/legacy/components/PatientInfo/PatientInfo.jsx